module.exports = __webpack_public_path__ + "img/home-principal2.790b1aac.png";